<template>
  <div class="operationGuideLayer" @click="changeStep">
    <transition name="fade">
      <div v-if="step === 1" class="step-one">
        <img src="static/images/guide_one_step.png" alt="">
      </div>
    </transition>
    <transition name="fade">
      <div v-if="step === 2" class="step-two">
        <img src="static/images/guide_two_step.png" alt="">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'OperationGuide',
  props: {
    step: Number
  },
  created () {},
  mounted () {
    console.log(this.step)
  },
  methods: {
    changeStep () {
      this.$emit('changeStep')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
  .operationGuideLayer {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.8);

    .step-one {
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      text-align: center;
      img {
        width: 468px;
      }
    }
    .step-two {
      width: 100%;
      bottom: 0;
      position: absolute;
      text-align: center;
      img {
        width: 482px;
      }
    }

    .fade-enter-active, .fade-leave-active {
      transition: all 1s ease;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  }
</style>
